import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import AdminInner from "../../../components/layout/admin_inner";
import {Typography} from "@mui/material";

export const AdminAccountingPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate("/app/admin/accounting/journal");
    }, []);

    return (
        <AdminInner>
            <Typography variant="h4">Módulo de Contabilidad</Typography>
        </AdminInner>
    );
};
